<template>
  <header
    class="sticky top-0 z-50 bg-white/90 dark:bg-background-dark/90 backdrop-blur-md border-b dark:border-slate-800"
  >
    <div class="container mx-auto px-6 py-2 flex items-center justify-between">
      <div class="flex items-center gap-2 cursor-pointer">
        <img width="90" src="@/assets/logo.jpg" alt="" />
      </div>

      <nav class="hidden md:flex items-center gap-8 text-sm font-medium h-full">
        <div
          v-for="item in menu"
          :key="item.name"
          class="relative group h-full flex items-center"
        >
          <span
            :href="item.link"
            :class="{
              'text-primary  border-b-2 border-primary': isActive(item.name)
            }"
            class="cursor-pointer text-[1.0rem] py-1 flex items-center gap-1 text-slate-600 dark:text-slate-300 hover:text-primary transition-colors"
            @click.stop="onMenuClick(item)"
            @mouseenter="onMenuEnter(item)"
          >
            {{ item.name }}
          </span>

          <div
            v-show="activeMenuName === 'Products'"
            class="mt-1 absolute top-[calc(100%-1px)] left-1/2 -translate-x-1/2 w-[850px] bg-white dark:bg-slate-900 shadow-2xl rounded-b-xl border border-t-0 opacity-0 invisible group-hover:opacity-100 group-hover:visible dark:border-slate-700 transition-all duration-300 z-50 p-10"
          >
            <div class="grid grid-cols-2">
              <div class="space-y-8">
                <div
                  class="cursor-pointer group/link"
                  v-for="(item, index) in prodectCategories"
                  :key="index"
                >
                  <div
                    class="flex items-center gap-2 font-bold text-xl uppercase italic"
                    :class="[
                      item.key === productActive
                        ? 'text-primary'
                        : 'text-slate-800 dark:text-slate-100 hover:text-primary transition-colors'
                    ]"
                    @mouseenter="productActive = item.key"
                    mouseleave="productActive = ''"
                  >
                    <span class="material-icons text-lg">chevron_right</span>
                    {{ item.title }}
                  </div>
                </div>
              </div>

              <div class="space-y-3">
                <div
                  v-for="(sub, idx) in productActive === 'HTV'
                    ? productLinesHTV
                    : productLinesLSR"
                  :key="idx"
                  class="flex items-start gap-2 group/sub cursor-pointer flex items-center"
                  @click.stop="onProductItemClick(sub)"
                >
                  <span class="material-icons text-primary text-sm mt-1"
                    >chevron_right</span
                  >
                  <span
                    class="text-slate-600 dark:text-slate-400 group-hover/sub:text-primary transition-colors leading-tight text-base font-normal"
                  >
                    {{ sub }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div class="flex items-center gap-4"></div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    isDark: Boolean
    // menu: Array
  },
  // watch: {
  //   $route: {
  //     handler(to, from) {
  //       console.log('==================')
  //       if (to.name === 'ProductsDetails') {
  //         this.updateMenuActive(null, 'Products')
  //       }
  //     }
  //   },
  //   deep: true, // 深度监听
  //   immediate: true // 立即执行一次
  // },
  data() {
    return {
      activeMenuName: '',
      menu: [
        { name: 'Home', link: '/' },
        { name: 'Products', link: '/products' }, // 激活状态
        { name: 'Applications', link: '/applications' },
        { name: 'About Us', link: '/aboutus' },
        { name: 'Download', link: '/download' },
        { name: 'Contact Us', link: '/contact' }
      ],
      prodectCategories: [
        {
          title: 'HTV Silicone Rubber',
          key: 'HTV'
        },
        {
          title: 'LIQUID SILICONE RUBBER',
          key: 'LSR'
        }
      ],
      productActive: '',
      productLinesHTV: [
        'General Purpose Silicone Rubber For Molding (Precipitated/Fumed)',
        'High Tear Strength Silicone Rubber For Molding (Precipitated/Fumed)',
        'High Resilience Silicone Rubber (Precipitated/Fumed)',
        'High Temperature Resistant Silicone Rubber',
        'Silicone Rubber for Extrusion (Precipitated/Fumed)',
        'High Transparent Fumed Silicone Rubber',
        'Electric Insulation Silicone Rubber',
        'Fire Retardant Silicone Rubber(Precipitated/Fumed)',
        'Roller Silicone Rubber'
      ],
      productLinesLSR: [
        'Liquid Silicone Rubber for Molding',
        'Liquid Silicone Rubber for Baby Care',
        'Liquid Silicone Rubber for Medical',
        'Liquid Silicone Rubber for Cable Accessories',
        'Liquid Silicone Rubber for  Food/Kitchen',
        'High Transparency Silicone Rubber',
        'Self-Adhesive Liquid Silocone Rubber'
      ]
    }
  },

  methods: {
    onMenuEnter(item) {
      this.activeMenuName = item.name
    },
    isActive(name) {
      // console.log(
      //   name,
      //   this.$route.name + 'xxxxxxxxxxxx',
      //   '======================'
      // )
      // console.log(name)
      if (name === 'Products' && this.$route.name === 'ProductsDetails') {
        return true
      }
      // console.log(this.$route.name, name)
      return this.$route.name === name
    },
    onMenuClick(item) {
      // this.updateMenuActive(item)
      let params = {
        path: item.link
      }
      if (item.name === 'Products') {
        params.query = {
          i: 'rK6w6tH26Z'
        }
      }
      this.$router.push(params)
    },
    onProductItemClick(title) {
      if (title.indexOf('(') > -1) {
        title = title.split('(')[0]
      }
      if (title.indexOf('/') > -1) {
        title = title.replace('/', ' ')
      }
      if (title.slice(-1) === ' ') {
        title = title.slice(0, -1)
      }
      // let t = 'jpg'
      // if (
      //   title.indexOf('Fire Retardant Silicone Rubber') > -1 ||
      //   title.indexOf('High Tear Strength Silicone Rubber For Molding') > -1
      // ) {
      //   t = 'png'
      // }
      // http://192.168.66.66:9899/products-details?n=High%20Tear%20Strength%20Silicone%20Rubber%20For%20Molding%20&t=jpg
      // http://192.168.66.66:9899/products-details?n=High%20Tear%20Strength%20Silicone%20Rubber%20For%20Molding&t=jpg
      let l = 'LSR Silicone Rubber'
      if (this.productActive === 'HTV') {
        l = 'HTV Silicone Rubber'
      }
      this.$router.push({
        path: '/products-details',
        query: { n: title, l: l, t: 'jpg' }
      })
      this.activeMenuName = ''
    },
    updateMenuActive(menu, menuName) {
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].active) {
          this.menu[i].active = false
          if (menuName) {
            if (menu.name === menuName) {
              this.menu[i].active = true
            }
          }
        }
      }
      if (menu) {
        menu.active = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/Navbar.vue